import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["query", "id", "results", "extra"]
  static values = { url: String, minLength: Number }

  connect() {
    this.timer = null
    this.syncExtra()
  }

  search() {
    window.clearTimeout(this.timer)
    this.idTarget.value = ""
    this.syncExtra()

    const query = this.queryTarget.value.trim()
    const minimum = this.hasMinLengthValue && this.minLengthValue > 0 ? this.minLengthValue : 2
    if (query.length < minimum) {
      this.close()
      return
    }

    this.timer = window.setTimeout(() => this.fetchResults(query), 200)
  }

  async fetchResults(query) {
    const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    })
    if (!response.ok) return

    this.render(await response.json())
  }

  render(items) {
    this.resultsTarget.replaceChildren()
    if (!items.length) {
      this.close()
      return
    }

    items.forEach((item) => {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "lookup-option"

      const name = document.createElement("span")
      name.textContent = item.name
      button.appendChild(name)

      if (item.detail) {
        const detail = document.createElement("small")
        detail.textContent = item.detail
        button.appendChild(detail)
      }

      button.addEventListener("mousedown", (event) => {
        event.preventDefault()
        this.choose(item)
      })
      this.resultsTarget.appendChild(button)
    })

    this.resultsTarget.hidden = false
  }

  choose(item) {
    this.idTarget.value = item.id
    this.queryTarget.value = item.name
    this.close()
    this.syncExtra()
  }

  close() {
    this.resultsTarget.hidden = true
    this.resultsTarget.replaceChildren()
  }

  syncExtra() {
    if (!this.hasExtraTarget) return

    const selected = this.idTarget.value !== ""
    this.extraTarget.hidden = selected
    this.extraTarget.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = selected
    })
  }
}
